import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  insCode: null,
};

export const insCodeSlice = createSlice({
  name: "insCode",
  initialState,
  reducers: {
    setInsCode: (state, action) => {
      state.insCode = action.payload;
    },
  },
});

export const { setInsCode } = insCodeSlice.actions;
export default insCodeSlice.reducer;
